import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notifications-modal" }
const _hoisted_2 = { class: "notifications-modal__tabs" }
const _hoisted_3 = {
  type: "button",
  class: "notifications-modal__move-all"
}
const _hoisted_4 = { class: "notifications-modal__list" }
const _hoisted_5 = {
  key: 0,
  class: "notifications-modal__divider"
}
const _hoisted_6 = {
  key: 2,
  class: "notifications-modal__empty"
}

import { computed, ref } from "vue"
import BaseModal from "@/components/common/modal/BaseModal.vue"
import AppLoader from "@/components/common/AppLoader.vue"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue"
import NotificationItem from "./NotificationItem.vue"
import NotificationMoveAllConfirm from "./NotificationMoveAllConfirm.vue"
import { headerStore } from "@/store/header"


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderNotificationsModal',
  setup(__props, { expose: __expose }) {

const store = headerStore()
const $modal = ref<typeof BaseModal | null>(null)
const $moveAllConfirm = ref<typeof AppResizableDropdown | null>(null)
const tab = ref<'active' | 'history'>('active')
const loading = ref(false)

const currentList = computed(() =>
	tab.value === 'active' ? store.activeNotifications : store.historyNotifications
)

const activeCount = computed(() => store.notificationCount.JobCount)

const canMoveAll = computed(() => tab.value === 'active' && store.activeNotifications.length > 0)

const loadCurrentTab = async () => {
	loading.value = true
	try {
		if (tab.value === 'active') {
			await store.loadActiveNotifications(0)
		} else {
			await store.loadHistoryNotifications(0)
		}
	} finally {
		loading.value = false
	}
}

const setTab = async (value: 'active' | 'history') => {
	tab.value = value
	await loadCurrentTab()
}

const onMoveToHistory = async (id: number) => {
	await store.moveNotificationToHistory(id)
}

const onConfirmMoveAll = async () => {
	$moveAllConfirm.value?.close()
	loading.value = true
	try {
		await store.moveAllToHistory()
	} finally {
		loading.value = false
	}
}

const open = async () => {
	$modal.value?.onOpen()
	tab.value = 'active'
	await loadCurrentTab()
}

const onClose = () => {

}

__expose({ open })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    title: "Уведомления о работе",
    width: "600px",
    height: "80vh",
    onOnClose: onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["notifications-modal__tab", { 'notifications-modal__tab--active': tab.value === 'active' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setTab('active')))
          }, " Новые (" + _toDisplayString(activeCount.value) + ") ", 3),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["notifications-modal__tab", { 'notifications-modal__tab--active': tab.value === 'history' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setTab('history')))
          }, " История ", 2),
          (canMoveAll.value)
            ? (_openBlock(), _createBlock(AppResizableDropdown, {
                key: 0,
                ref_key: "$moveAllConfirm",
                ref: $moveAllConfirm,
                class: "notifications-modal__move-all-wrap",
                position: "bottom",
                "max-width": 280,
                "content-z-index": 10002,
                "close-by-click-outside": ""
              }, {
                activator: _withCtx(() => [
                  _createElementVNode("button", _hoisted_3, [
                    _cache[3] || (_cache[3] = _createTextVNode(" Переместить все в историю ")),
                    _createVNode(AppIcon, {
                      name: "rollback",
                      size: "18px",
                      class: "notifications-modal__move-all-icon",
                      style: { marginTop: '-2px' }
                    })
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(NotificationMoveAllConfirm, {
                    onConfirm: onConfirmMoveAll,
                    onCancel: _cache[2] || (_cache[2] = ($event: any) => ($moveAllConfirm.value?.close()))
                  })
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (loading.value)
            ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
            : (currentList.value.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(currentList.value, (n, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: n.Id
                  }, [
                    _createVNode(NotificationItem, {
                      notification: n,
                      "show-move-action": tab.value === 'active',
                      onMoveToHistory: onMoveToHistory
                    }, null, 8, ["notification", "show-move-action"]),
                    (index + 1 < currentList.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, " Список пуст "))
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})